
import {
  defineComponent,
} from 'vue';
import { useI18n } from 'vue-i18n';
import Tooltip from 'primevue/tooltip';
import type { IntegrationKind } from '@/types/integrations';

export interface AppWidget {
  id: string;
  type?: string;
  group?: string;
  label: string;
  appName: string;
  iconClass?: string;
  iconImage?: string;
  installed: boolean;
  marketplaceUrl?: string;
  // Integration widgets: identify the concrete widget at drop / config time.
  integrationSlug?: string;
  widgetKey?: string;
  kind?: IntegrationKind;
}

export default defineComponent({
  name: 'AppWidgetButton',

  directives: {
    tooltip: Tooltip,
  },

  props: {
    appWidget: {
      type: Object as () => AppWidget,
      required: true,
    },
    // Native-look variant (first-party widgets listed among native widgets):
    // hide the install badge / app subtitle / install link → icon + label only.
    compact: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['install'],

  setup() {
    const { t } = useI18n();
    return { t };
  },
});
